import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandableContainerWithHeader, ExpandableContainerWithHeaderProps } from 'record-it-components/misc/ExpandableContainerWithHeader/ExpandableContainerWithHeader';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { DurationUtils } from 'record-it-utils/utils/DurationUtils/DurationUtils';
import { WorkTimeEntryUtils } from '../../../classes/entities/WorkTimeEntry/WorkTimeEntryUtils';
import { useTodaysWorkTimeEntries } from '../../../hooks/entity/workTimeEntry/useTodaysWorkTimeEntries/useTodaysWorkTimeEntries';
import { TodaysWorkTimeInfoDetailEntry } from '../TodaysWorkTimeInfoDetailEntry/TodaysWorkTimeInfoDetailEntry';
import styles from './TodaysWorkTimeInfo.module.css';
export type TodaysWorkTimeInfoProps = PropsWithoutChildren<ComponentProps<'div'>>;
export const TodaysWorkTimeInfo: FunctionComponent<TodaysWorkTimeInfoProps> = React.memo(props => {
  const $ = _c(25);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  if ($[2] !== t0) {
    ({
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
  } else {
    remainingProps = $[3];
  }
  const {
    t
  } = useTranslation();
  const workTimeEntries = useTodaysWorkTimeEntries();
  let t1;
  if ($[4] !== workTimeEntries) {
    t1 = DurationUtils.formatDurationToHourMinuteString(WorkTimeEntryUtils.getWorkTimeEntriesDurationSum(workTimeEntries));
    $[4] = workTimeEntries;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const formattedWorkTime = t1;
  let t2;
  if ($[6] !== t || $[7] !== workTimeEntries.length) {
    t2 = t3 => {
      const {
        expanded
      } = t3;
      return t("components.workTime.TodaysWorkTimeInfo.moreInfosTitle", {
        count: workTimeEntries.length,
        context: expanded ? "expanded" : ""
      });
    };
    $[6] = t;
    $[7] = workTimeEntries.length;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const renderHeader = t2;
  let t3;
  if ($[9] !== t) {
    t3 = t("components.workTime.TodaysWorkTimeInfo.workTime");
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <span>{t3}</span>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== formattedWorkTime) {
    t5 = <span data-testid="TodaysWorkTimeInfo.WorkTime">{formattedWorkTime}</span>;
    $[13] = formattedWorkTime;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== renderHeader || $[19] !== workTimeEntries) {
    t7 = workTimeEntries.length > 0 ? <ExpandableContainerWithHeader renderHeader={renderHeader} className={styles.detailContainer} data-testid="TodaysWorkTimeInfo.DetailsExpandableContainer"><div className={styles.detailEntriesList}>{workTimeEntries.map(_temp)}</div></ExpandableContainerWithHeader> : null;
    $[18] = renderHeader;
    $[19] = workTimeEntries;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== remainingProps || $[22] !== t6 || $[23] !== t7) {
    t8 = <div {...remainingProps}>{t6}{t7}</div>;
    $[21] = remainingProps;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
});
function _temp(workTimeEntry) {
  return <TodaysWorkTimeInfoDetailEntry key={EntityUtils.getTrackingKey(workTimeEntry)} workTimeEntry={workTimeEntry} data-testid="TodaysWorkTimeInfo.DetailEntry" />;
}